import { useQuery } from '@apollo/client/react/hooks';
import { useMemo } from 'react';

import { GetStoryModuleDocument } from '../../graphql/generated/graphql';
import { isStoryModule } from '../../types';
import { NotFoundError, BadRequestError } from '../../utils/errors';

interface Props {
  id: string;
  company: string;
}

export const useGetStoryModule = ({ id, company }: Props) => {
  const { data, loading, ...rest } = useQuery(GetStoryModuleDocument, {
    variables: { id },
    skip: Number.isNaN(id),
  });

  const storyModule = useMemo(() => {
    if (loading) return;
    if (data?.module) {
      const { module } = data;
      if (!module) throw new NotFoundError('Story Module not found');
      if (module.Product?.Company?.Slug !== company)
        throw new BadRequestError(
          `Story module ${module.id} (company slug: ${module.Product?.Company?.Slug}) is not owned by company ${company}`
        );
      if (isStoryModule(module)) return module;
    }
  }, [data, loading, company]);

  return { storyModule, ...rest };
};
